import React, { useContext, useEffect, useMemo } from 'react';
import Context from './context';
import { IdRoute } from '../../../../../types';
import useServiceReducer from '../../../../../shared/hooks/useServiceReducer';
import supervisionReportReducer from './supervisionReportReducer';
import operSupervisionReportService from '../../../../../services/operSupervisionReportService';
import { SpinnerArea } from '../../../../../shared/components';
import MainContext from '../../../../App/MainProvider/context';

const SupervisionReportProvider: React.FC<IdRoute> = ({ id, children }) => {
  const { inSuperUserMode, inGuidanceServiceMode } = useContext(MainContext);
  const [data, loading, , , loader, reload] = useServiceReducer(
    operSupervisionReportService.getFlow,
    supervisionReportReducer,
    parseInt(id, 10)
  );
  useEffect(() => {
    reload(parseInt(id, 10));
  }, [id, inSuperUserMode(), inGuidanceServiceMode()]);
  const value = useMemo(
    () => (data ? { data, loading, loader, reload } : null),
    [data, loading, loader, reload]
  );
  return (
    <SpinnerArea loading={loading}>
      {value && <Context.Provider value={value}>{children}</Context.Provider>}
    </SpinnerArea>
  );
};

export default SupervisionReportProvider;
